import { useRouter } from 'next/router';

export function useClassroomId(): string | undefined {
  const id = useRouter().query.classroomId;
  if (typeof id !== 'string' || id.length === 0) return undefined;
  return id;
}
